import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  CSpinner,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'
import { getCompletedOrders } from 'src/redux/orders'

const OrdersCompleted = () => {
  const dispatch = useDispatch()
  const { completedOrders, loading, error } = useSelector((state) => state.orders)

  useEffect(() => {
    dispatch(getCompletedOrders())
  }, [dispatch])

  if (loading) return <CSpinner color="primary" className="d-block mx-auto my-4" />
  if (error) return <p className="text-danger text-center">Error: {error}</p>
  if (!Array.isArray(completedOrders) || completedOrders.length === 0)
    return <p className="text-center">No orders found</p>

  return (
    <CTable striped hover responsive>
      <CTableHead color="dark">
        <CTableRow>
          <CTableHeaderCell>#</CTableHeaderCell>
          <CTableHeaderCell>Order No</CTableHeaderCell>
          <CTableHeaderCell>Order Status</CTableHeaderCell>
          <CTableHeaderCell>Total Amount (₹)</CTableHeaderCell>
          <CTableHeaderCell>Delivery Charges (₹)</CTableHeaderCell>
          <CTableHeaderCell>Discount (₹)</CTableHeaderCell>
          <CTableHeaderCell>Payment Method</CTableHeaderCell>
          <CTableHeaderCell>Order Date</CTableHeaderCell>
          <CTableHeaderCell>Delivery Date</CTableHeaderCell>
          <CTableHeaderCell>Billing Address</CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {completedOrders.map((order, index) => (
          <CTableRow key={order.id}>
            <CTableDataCell>{index + 1}</CTableDataCell>
            <CTableDataCell>{order.order_no}</CTableDataCell>
            <CTableDataCell>
              <span
                className={`badge ${
                  order.order_status === 'completed' ? 'bg-success' : 'bg-warning'
                }`}
              >
                {order.order_status}
              </span>
            </CTableDataCell>
            <CTableDataCell>₹{order.total_amount}</CTableDataCell>
            <CTableDataCell>₹{order.delivery_charges}</CTableDataCell>
            <CTableDataCell>₹{order.coupons_discount}</CTableDataCell>
            <CTableDataCell>{order.payment_method}</CTableDataCell>
            <CTableDataCell>{new Date(order.order_date).toLocaleDateString()}</CTableDataCell>
            <CTableDataCell>{new Date(order.delivered_date).toLocaleDateString()}</CTableDataCell>
            <CTableDataCell>{order.billing_address}</CTableDataCell>
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  )
}

export default OrdersCompleted
